import i18n from '@/lang'

export default {
    loginUserType(state) {     // 当前登录账号类型: adm dh zeal agencyX
        return state.userCompanyInfo.type
    },

    supplierUserType(state) {
        return state.userCompanyInfo.permissionScope
    },

    mainAccount(state) {
        return state.userCompanyInfo.mainAccount
    },

    aiExtractEnabled(state) {
        return state.userCompanyInfo.aiExtract
    },

    isEAPersonnel(state) {
        return state.userCompanyInfo.roleNames && state.userCompanyInfo.roleNames.includes('EA Personnel')
    },

    supplierUserId(state) {
        return state.userCompanyInfo.supplierId
    },

    isAdminAndNotSelected(state) {       // admin登录且没选中介
        return state.userCompanyInfo.type === 'adm' && !state.adminSelectedCompany.id
    },

    isAdminAndSelected(state) {         // admin登录且选了中介
        return state.userCompanyInfo.type === 'adm' && state.adminSelectedCompany.id
    },

    currentUserCompany(state) {         // 当前公司
        return state.userCompanyInfo.type === 'adm' && state.adminSelectedCompany.id ? state.adminSelectedCompany : state.userCompanyInfo
    },

    isHKCompany(state) {
        return state.userCompanyInfo.countryAreaId === 1098
    },

    isSGCompany(state) {
        return state.userCompanyInfo.countryAreaId === 1192
    },

    isMYCompany(state) {
        return state.userCompanyInfo.countryAreaId === 1129
    },

    isAgencySide(state) { // 是否为agency侧
        return state.userCompanyInfo.type === 'agency'
    },

    isATypeAgency(state) { // 在supply on是不是A类agency
        return state.userCompanyInfo.agencyTypeWithSupplierOn === 'A'
    },

    isSupplierSide(state) { // 是否为supplier侧
        return state.userCompanyInfo.type === 'supplier'
    },

    isTransportSide(state) { // 是否为transport侧
        return state.userCompanyInfo.type === 'transport'
    },

    isInsuranceSide(state) { // 是否为insurance侧
        return state.userCompanyInfo.type === 'insurance'
    },

    isLendingSide(state) { // 是否为lending侧
        return state.userCompanyInfo.type === 'lending'
    },

    isTrainingSide(state) { // 是否为Training侧
        return state.userCompanyInfo.type === 'training'
    },

    isSupplyOnSubCompany(state) { // 是MM/PH/ID - supply on这三家子公司
        return [13044, 13045, 13046, 25548].includes(state.userCompanyInfo.id)
    },

    isSupplyOnPH(state) { // 是supply on- PH这子公司
        return state.userCompanyInfo.id === 13045
    },

    isSupplyOn(state) { // 是supply on
        return state.userCompanyInfo.id === 6
    },

    isSupplyOnAllCompany(state) { // 是supply on和它的子公司
        return state.userCompanyInfo.isSupplierOn
    },

    isGoogleVerifyAccount(state) { // 是否为google验证账号
        return state.userInfo.userId === 248
    },

    isExternalSupplier(state) { // 新建了一个虚拟supplier(公司名"External Supplier")用来分发非supply on女佣到zeal、hometrust、jobsearch
        return state.userCompanyInfo.identityNo === '3C5BB24A'
    },

    feeTypeList(state) {
        let list: any = []
        switch (state.userCompanyInfo.type) {
            case 'agency':
                list = [
                    { label: i18n.t('package_fee_deposit'), value: 1 },
                    { label: i18n.t('package_fee_balance'), value: 2 },
                    { label: i18n.t('placement_fee'), value: 3 },
                    { label: i18n.t('ad_hoc_arrangment'), value: 4 },
                    { label: i18n.t('after_sales_charge'), value: 8 },
                    { label: i18n.t('fees_charged_to_helper'), value: 11 },
                    { label: i18n.t('fees_charged_to_agency'), value: 16 },
                ]
                break
            case 'supplier':
                list = [
                    { label: i18n.t('standard_charge_balance'), value: 5 },
                    { label: i18n.t('standard_charge_deposit'), value: 9 },
                    { label: i18n.t('other_fee'), value: 6 },
                    { label: 'Commission Fee', value: 17 },
                    { label: i18n.t('fees_charged_to_helper'), value: 11 },
                ]
                break
            case 'transport':
                list = [
                    { label: i18n.t('transport_fee'), value: 7 },
                ]
                break
            case 'insurance':
                list = [
                    { label: i18n.t('gross_premium'), value: 10 },
                ]
                break
            case 'lending':
                list = [
                    { label: 'Principal', value: 12 },
                    { label: 'Interest', value: 13 },
                    { label: 'Service Fee', value: 14 },
                ]
                break
            case 'training':
                list = [
                    { label: i18n.t('other_fee'), value: 6 },
                    { label: 'Training Fee', value: 15 },
                ]
                break
            default:
                break
        }
        return list
    },

    paymentChannelMap(state) {
        let list: any = [{
            name: 'Bank Transfer',
            value: 2,
        }, {
            name: 'Cash',
            value: 1,
        }, {
            name: 'Cash Deposit',
            value: 4,
        }, {
            name: 'Cheque',
            value: 3,
        }]
        return list
    },

    agencyDetailRouteName(state) {
        switch(state.userCompanyInfo.type) {
            case 'supplier':
                return 'SupplierAgencyDetail'
            case 'transport':
                return 'pjAgencyDetail'
            case 'insurance':
                return 'insuranceAgencyDetail'
            case 'agency':
                return 'AgencySideAgencyDetail'
        }
    }
}
